import axios from "axios";
import qs from "qs";

let baseURL = "http://121.196.146.156:8088/";
let timeout = 5000; //

// 如果失败 则使用 const http = {} 替换 export default
export default {
    post(url, data) {
        return axios({
            method: "post",
            url: `${baseURL}${url}`,
            data: qs.stringify(data),
            timeout: timeout
        });
    },
    put(url, data) {
        return axios({
            method: "put",
            url: `${baseURL}${url}`,
            data: qs.stringify(data),
            timeout: timeout
        });
    },
    delete(url, data) {
        return axios({
            method: "delete",
            url: `${baseURL}${url}`,
            data: qs.stringify(data),
            timeout: timeout,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        });
    },
    get(url, params) {
        return axios({
            method: "get",
            url: `${baseURL}${url}`,
            params: params,  // get 请求时带的参数
            timeout: timeout
        });
    }
}
